import type { RouteObject } from "react-router-dom";
import StJeanChrysostome from "../pages/secteurs/saint-jean-chrysostome/page";
import Pintendre from "../pages/secteurs/pintendre/page";
import Charny from "../pages/secteurs/charny/page";
import SaintNicolas from "../pages/secteurs/saint-nicolas/page";
import SaintRomuald from "../pages/secteurs/saint-romuald/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";
import MentionsLegales from "../pages/mentions-legales/page";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ToitureLevis from "../pages/toiture-levis/page";
import Refection from "../pages/refection-toiture-levis/page";
import Reparation from "../pages/reparation-toiture-levis/page";
import ToitPlat from "../pages/toit-plat-membrane-elastomere/page";
import ToleMetal from "../pages/toiture-tole-metal/page";
import Bardeau from "../pages/bardeau-asphalte/page";
import Inspection from "../pages/inspection-toiture/page";
import Deneigement from "../pages/deneigement-toiture/page";
import Soumission from "../pages/soumission-gratuite/page";
import APropos from "../pages/a-propos/page";
import BlogPrix from "../pages/blog/prix-toiture-levis-2026/page";
import BlogChoisir from "../pages/blog/comment-choisir-couvreur-levis/page";
import BlogSignes from "../pages/blog/signes-toiture-a-refaire/page";
import Merci from "../pages/merci/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/toiture-levis",
    element: <ToitureLevis />,
  },
  {
    path: "/refection-toiture-levis",
    element: <Refection />,
  },
  {
    path: "/reparation-toiture-levis",
    element: <Reparation />,
  },
  {
    path: "/toit-plat-membrane-elastomere",
    element: <ToitPlat />,
  },
  {
    path: "/toiture-tole-metal",
    element: <ToleMetal />,
  },
  {
    path: "/bardeau-asphalte",
    element: <Bardeau />,
  },
  {
    path: "/inspection-toiture",
    element: <Inspection />,
  },
  {
    path: "/deneigement-toiture",
    element: <Deneigement />,
  },
  {
    path: "/soumission-gratuite",
    element: <Soumission />,
  },
  {
    path: "/a-propos",
    element: <APropos />,
  },
  {
    path: "/blog/prix-toiture-levis-2026",
    element: <BlogPrix />,
  },
  {
    path: "/blog/comment-choisir-couvreur-levis",
    element: <BlogChoisir />,
  },
  {
    path: "/blog/signes-toiture-a-refaire",
    element: <BlogSignes />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/secteurs/saint-jean-chrysostome",
    element: <StJeanChrysostome />,
  },
  {
    path: "/secteurs/pintendre",
    element: <Pintendre />,
  },
  {
    path: "/secteurs/charny",
    element: <Charny />,
  },
  {
    path: "/secteurs/saint-nicolas",
    element: <SaintNicolas />,
  },
  {
    path: "/secteurs/saint-romuald",
    element: <SaintRomuald />,
  },
  {
    path: "/merci",
    element: <Merci />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;